module.exports = __webpack_public_path__ + "fonts/Museo-Sans-700.ttf";